import { Box, Button, FormControl, FormControlLabel, FormLabel, Paper, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { styled } from '@mui/system';


const Wrapper = styled(Paper)({
    marginTop: "16px",
    padding: '12px',
});

const Title = styled(Typography)({
    marginBottom: '8px',
    fontWeight: '500',
});

const EspelhoFilter = ({ handleFilterChange, filters }) => {
    return (
        <Wrapper elevation={0}>
            <Title>Filtros</Title>
            <Grid container spacing={2}>
                <Grid xs={6}>
                    <Box sx={{}}>
                        <TextField
                            id="input-number"
                            name='label'
                            label="Número"
                            variant="outlined"
                            value={filters.label}
                            onChange={(e) => handleFilterChange('label', e.target.value)}
                            fullWidth
                        />
                    </Box>
                </Grid>
                <Grid xs={6}>
                    <Box sx={{ width: '100%', height: '100%' }}>
                        <FormControl sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value={filters.connectionStatus}
                                onChange={(e) => handleFilterChange('connectionStatus', e.target.value)}
                            >
                                <FormControlLabel value="" control={<Radio />} label="Todos" />
                                <FormControlLabel value="Connected" control={<Radio />} label="Online" />
                                <FormControlLabel value="disconnected" control={<Radio />} label="Offline" />
                            </RadioGroup>
                        </FormControl>
                    </Box>
                </Grid>
                {/* <Grid xs={6}>
                    <Button variant="contained" fullWidth>Filtrar</Button>
                </Grid>
                <Grid xs={6}>
                    <Button variant="contained" color='secondary' fullWidth>Limpar</Button>
                </Grid> */}
            </Grid>
        </Wrapper>
    )
}
export default EspelhoFilter;